/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

function BestFriends() {
  return (
    <>
      <div className="section section-dark text-center gradient-background-claro">
        <Container>
          <h2 className="title gradient-title"> My best friends </h2>
          <hr style={{ clear: 'both' }} />
          <Row>

            <Col md="2">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Ruben.png")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <div className="author">
                      <CardTitle tag="h4"> Ventor </CardTitle>
                    </div>
                  </a>
                </CardBody>
              </Card>
            </Col>

            <Col md="2">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/NekoZen.png")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <div className="author">
                      <CardTitle tag="h4"> NekoZen </CardTitle>
                    </div>
                  </a>
                </CardBody>
              </Card>
            </Col>

            <Col md="2">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Madosuki.png")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <div className="author">
                      <CardTitle tag="h4"> Madosuki </CardTitle>
                    </div>
                  </a>
                </CardBody>
              </Card>
            </Col>

            <Col md="2">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.instagram.com/torukprogressive" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Toruk.png")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.instagram.com/torukprogressive" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> Toruk Progressive </CardTitle>
                    </div>
                  </a>
                </CardBody>
              </Card>
            </Col>

            <Col md="2">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.instagram.com/momoirokath" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Dpper.png")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.instagram.com/momoirokath" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> Dpper </CardTitle>
                    </div>
                  </a>
                </CardBody>
              </Card>
            </Col>

            <Col md="2">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Coso.jpg")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <div className="author">
                      <CardTitle tag="h4"> Coso </CardTitle>
                    </div>
                  </a>
                </CardBody>
              </Card>
            </Col>

            <Col md="2" />

            <Col md="2">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Cuyi_Hermoso.png")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <div className="author">
                      <CardTitle tag="h4"> Cuyi hermoso </CardTitle>
                    </div>
                  </a>
                </CardBody>
              </Card>
            </Col>

            <Col md="2">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/DualWolf.png")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <div className="author">
                      <CardTitle tag="h4"> DualWolf </CardTitle>
                    </div>
                  </a>
                </CardBody>
              </Card>
            </Col>

            <Col md="2">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.instagram.com/shionshetrr" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/Franny.png")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.instagram.com/shionshetrr" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> Franny </CardTitle>
                    </div>
                  </a>
                </CardBody>
              </Card>
            </Col>

            <Col md="2">
              <Card className="card-profile card-plain">
                <div className="card-avatar">
                  <a href="https://www.instagram.com/jcuevas1995" target="_blank" rel="noopener noreferrer" >
                    <img
                      alt="..."
                      src={require("assets/img/SpecialThanks/CAJ002.png")}
                    />
                  </a>
                </div>
                <CardBody>
                  <a href="https://www.instagram.com/jcuevas1995" target="_blank" rel="noopener noreferrer" >
                    <div className="author">
                      <CardTitle tag="h4"> CAJ002 </CardTitle>
                    </div>
                  </a>
                </CardBody>
              </Card>
            </Col>

            <Col md="12">
              <Card className="card-plain">
                <p className="card-description text-center">
                  For all the patience and dedication to see that I can improve ❤
                  </p>
              </Card >
            </Col >

            <Col md="2" />

          </Row>

        </Container>
      </div>
    </>
  );
}

export default BestFriends;
